module.exports = "\n  <span class=\"footer\">&copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }}</span>\n\n"